import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../../shared/shared.module";
import { DirectionFilterComponent } from "./direction-filter/direction-filter.component";
import { FilterButtonComponent } from "./filter-button/filter-button.component";
import { FiltersComponent } from "./filters.component";
import { LineNumberFilterComponent } from "./line-number-filter/line-number-filter.component";
import { LineNumberPickerComponent } from "./line-number-filter/line-number-picker/line-number-picker.component";
import { TimeFilterComponent } from "./time-filter/time-filter.component";
import { TimePickerComponent } from "./time-filter/time-picker/time-picker.component";
import { TrainNumberFilterComponent } from "./train-number-filter/train-number-filter.component";
import { TrainNumberPickerComponent } from "./train-number-filter/train-number-picker/train-number-picker.component";

@NgModule({
  declarations: [
    DirectionFilterComponent,
    FilterButtonComponent,
    LineNumberFilterComponent,
    LineNumberPickerComponent,
    TimeFilterComponent,
    TrainNumberFilterComponent,
    TimePickerComponent,
    TrainNumberPickerComponent,
    FiltersComponent,
  ],
  imports: [CommonModule, SharedModule, BrowserAnimationsModule],
  exports: [
    DirectionFilterComponent,
    FilterButtonComponent,
    LineNumberFilterComponent,
    LineNumberPickerComponent,
    TimeFilterComponent,
    TrainNumberFilterComponent,
    TimePickerComponent,
    TrainNumberPickerComponent,
    FiltersComponent,
  ],
})
export class FiltersModule {}
